import { render, staticRenderFns } from "./admin_page.vue?vue&type=template&id=2c9af874&scoped=true&"
import script from "./admin_page.vue?vue&type=script&lang=js&"
export * from "./admin_page.vue?vue&type=script&lang=js&"
import style0 from "./admin_page.vue?vue&type=style&index=0&id=2c9af874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9af874",
  null
  
)

export default component.exports